import React from 'react'
import { UnloadedElectionDefinition } from '../data/election/electionTypes'

/**
 * Builds the site's definition (logo, meta) for a wan election id, e.g.
 * `vic-election-2026`. Provided by sites that support election embeds, so
 * shared components such as article embeds get the site's election config.
 */
export type ElectionDefinitionResolver = (
    wanElectionId: string,
) => UnloadedElectionDefinition

export const ElectionDefinitionContext = React.createContext<
    ElectionDefinitionResolver | undefined
>(undefined)
